import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import './index.css'
import classNames from 'classnames'

function noop () {}

const unmountStacks = []
let __stackIndex = -1

const Toast = props => {
  const cls = classNames('realsee-design-toast', props.className)
  
  return (
      <div className={cls}>
        <div className="react-toast-contain">
          {props.children}
        </div>
      </div>
  )
}

Toast.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
}

const __toastCreater = ({ content, duration = 1.5, onClose = noop, ...restProps }) => {
  const stackIndex = ++__stackIndex
  const container = document.createElement('div')
  document.body.appendChild(container)
  let unmount = () => {
    unmount = noop
    unmountStacks[stackIndex] = null
    ReactDOM.unmountComponentAtNode(container)
    container.parentNode.removeChild(container)
    onClose()
  }

  unmountStacks[stackIndex] = unmount
  
  ReactDOM.render(<Toast {...restProps}>{content}</Toast>, container)

  if (duration !== 0) {
    setTimeout(unmount, duration * 1000)
  }
  return unmount
}

Toast.error = (...args) => {
  const config = {
    content: args[0],
    className: 'react-toast-error'
  }
  if (args[1] !== undefined) {
    config.duration = args[1]
  }
  if (args[2] !== undefined) {
    config.onClose = args[2]
  }
  return __toastCreater(config)
}

Toast.success = (...args) => {
  const config = {
    content: args[0],
    className: 'react-toast-success'
  }
  if (args[1] !== undefined) {
    config.duration = args[1]
  }
  if (args[2] !== undefined) {
    config.onClose = args[2]
  }
  return __toastCreater(config)
}

Toast.unmount = () => {
  unmountStacks.forEach(unmount => {
    unmount && unmount()
  })
}

export default Toast
